(function() {

    angular
        .module('ngmvac')
        .factory('variablesService', VariablesService);

    function VariablesService() {
        return {
            pathImages       : 'https://photos.hotelbeds.com/giata',
            pathImagesMedium : 'https://photos.hotelbeds.com/giata/medium',
            pathImagesBigger : 'https://photos.hotelbeds.com/giata/bigger',
            starFilter : {
                one     : {
                    selected: false,
                    visible: true
                },
                two     : {
                    selected: false,
                    visible: true
                },
                three   : {
                    selected: false,
                    visible: true
                },
                four    : {
                    selected: false,
                    visible: true
                },
                five    : {
                    selected: false,
                    visible: true
                },
                otros   : {
                    selected: false,
                    visible: true
                },
                reset   : function() {
                    for (var field in this) {
                        if (typeof this[field] == 'object') {
                            this[field].selected = false;
                            this[field].visible = true;
                        }
                    }
                },
                hidden  : function() {
                    for (var field in this) {
                        if (typeof this[field] == 'object') {
                            this[field].visible = false;
                        }
                    }
                }
            },
            sliderOptions : {
                min     : 1000,
                max     : 20000,
                options : {
                    floor       : 0,
                    ceil        : 100000,
                    onChange    : function() {
                        vm.unirfiltros();
                    }
                }
            },
            selectParams : {
                room: {
                    options : [ 1, 2, 3, 4, 5 ],
                    value   : 1
                },
                adults: {
                    options: [1, 2, 3, 4, 5]
                },
                children: {
                    options: [0, 1, 2, 3, 4, 5]
                },
                childrenAge: {
                    options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
                },
                itemsPage: {
                    options: [10, 20, 30]
                }
            },
            alojamiento: ['Todas'], //alojamiento : ['Todas', 'Apartamento', 'Aparthotel', 'Camping', 'Villa', 'Albergue', 'Hotel', 'Pendiente categoría', 'Resort', 'Agroturismo'],
            roomsInfo : [
                {
                    nHabitacion : 1,
                    adults      : 2,
                    children    : 0,
                    edadNinios  : []
                }
            ],
            tripAdvisor : "https://www.tripadvisor.com/WidgetEmbed-cdspropertydetail?display=true&partnerId=6CA95E2409844D6183003CEFCDDC2BDE&lang=es&locationId="
        }
    }

})();
